import { useState } from "react";
import { supabase } from "@/libs/supabase";
import { useAuth } from "../useAuth";

interface UpdateCommentParams {
	commentId: string;
	content: string;
}

export const useUpdateComment = () => {
	const [loading, setLoading] = useState(false);
	const { user } = useAuth();

	const updateComment = async ({ commentId, content }: UpdateCommentParams) => {
		if (!user) throw new Error("認証が必要です");

		setLoading(true);
		try {
			const { data, error } = await supabase
				.from("comments")
				.update({ content })
				.eq("id", commentId)
				.eq("user_id", user.id)
				.select("*, user:users(*)");

			if (error) throw error;
			return data[0];
		} finally {
			setLoading(false);
		}
	};

	return { updateComment, loading };
};
